var _rect, _rect2, _rect3, _rect4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42.9629,
    height: 40,
    fill: "url(#pattern0)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 9,
    width: 4,
    height: 4,
    fill: "#FFC477"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 9,
    width: 4,
    height: 4,
    fill: "#FFC477"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.7969,
    y: 13.125,
    width: 5.37036,
    height: 2.5,
    fill: "#FFC477"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_567_4114",
    transform: "matrix(0.015625 0 0 0.0167824 0 -0.0370361)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_567_4114",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.b0563692de80a67b38ba79acb1c409ad.svg";
export { ForwardRef as ReactComponent };